import React from 'react';
import PropTypes from 'prop-types';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const IconArrowUp = ({colour}) => {
    const arrowColour = colour || 'white';
    return (
        <svg
            fill='none'
            style={{ width: '16px', height: '16px' }}
            viewBox='0 0 16 10'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M0 9.71997V8.30997L8.02 0.279971L16 8.29997V9.71997L8.02 1.69997L0 9.71997Z'
                fill={arrowColour}/>
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

IconArrowUp.propTypes = {
    colour: PropTypes.string
};

export default IconArrowUp;
